module.exports = __webpack_public_path__ + "static/project-2-1-5bb0240e076f87c0e9f6d7729fb2c059.jpg";